import(/* webpackMode: "eager" */ "/var/www/html/demo.klugora.com/klugcmms/src/app/forgot-password/page.tsx");
